module.exports = __webpack_public_path__ + "img/casino-on-line-com.3429093d.svg";